export default __webpack_public_path__ + "static/media/category-9.de6cb391.jpg";